'use client'

import React, { use } from 'react'
import { useCart, useSearchParams } from '@/lib/hooks'

import { RefContext, Refs } from '@/components/providers/ref-provider'

export const useBarcode = () => {
  const [isListening, setIsListening] = React.useState(false)
  const { addToCartByBarcode } = useCart()
  const { barcodeInputRef } = use(RefContext) as Refs
  const { cartId } = useSearchParams()

  // If the barcode input is focused, set the listening state to true
  React.useEffect(() => {
    const onFocus = () => setIsListening(true)
    const onBlur = () => setIsListening(false)

    if (barcodeInputRef.current) {
      barcodeInputRef.current.addEventListener('focus', onFocus)
      barcodeInputRef.current.addEventListener('blur', onBlur)
    }

    return () => {
      if (barcodeInputRef.current) {
        barcodeInputRef.current.removeEventListener('focus', onFocus)
        barcodeInputRef.current.removeEventListener('blur', onBlur)
      }
    }
  }, [barcodeInputRef])

  const focusBarcodeInput = () => barcodeInputRef?.current?.focus()

  const clearBarcodeInput = () => {
    if (barcodeInputRef.current) {
      barcodeInputRef.current.value = ''
    }
  }

  const submitBarcodeProduct = (data: FormData) => {
    const barcode = data?.get('barcode-value')
    if (barcode) {
      addToCartByBarcode({ barcode, cartId })
    }
    clearBarcodeInput()
  }

  return {
    focusBarcodeInput,
    clearBarcodeInput,
    submitBarcodeProduct,
    isListening,
  }
}
